import React from "react"

import { ThreeDots } from "react-loader-spinner"


function Spinner () {
    return <ThreeDots color="#1C64F2" radius={1}/>
}

export default Spinner